
import { Component, Prop, Ref, Vue } from 'vue-property-decorator'
import LabelBase from '@/components/atoms/LabelBase.vue'
import ImageBase from '@/components/atoms/ImageBase.vue'
import ModalWindow from '@/components/molecules/ModalWindow.vue'
import InputText from '@/components/molecules/InputText.vue'
import InputPassword from '@/components/molecules/InputPassword.vue'
import SquareSelect from '@/components/molecules/SquareSelect.vue'
import ButtonSubmit from '@/components/molecules/ButtonSubmit.vue'
import { SelectItem } from '@/models/SelectItem'
import StringUtils from '@/utils/StringUtils'

/**
 * 仮生徒登録モーダルのフォーマット
 */
@Component({
  components: {
    LabelBase,
    ImageBase,
    ModalWindow,
    InputText,
    InputPassword,
    SquareSelect,
    ButtonSubmit,
  },
})
export default class ModalTemporaryStudentData extends Vue {
  /** モーダル分子 */
  @Ref()
  modalWindow!: ModalWindow

  /** 学年選択コンポーネント */
  @Ref()
  gradeSelect!: SquareSelect

  /** 教室選択コンポーネント */
  @Ref()
  branchSelect!: SquareSelect

  /** コース選択コンポーネント */
  @Ref()
  courseSelect!: SquareSelect

  /** クラス選択コンポーネント */
  @Ref()
  classSelect!: SquareSelect

  /** 学年選択肢 */
  @Prop()
  private gradeOptions!: SelectItem

  /** 学年選択の初期値 */
  @Prop()
  private defaultGradeCode!: string

  /** 教室選択肢 */
  @Prop()
  private branchOptions!: SelectItem

  /** 教室選択の初期値 */
  @Prop()
  private defaultBranchCode!: string

  /** コース選択肢 */
  @Prop()
  private courseOptions!: SelectItem

  /** コース選択の初期値 */
  @Prop()
  private defaultCourseCode!: string

  /** クラス選択肢 */
  @Prop()
  private classOptions!: SelectItem

  /** クラス選択の初期値 */
  @Prop()
  private defaultClassCode!: string

  /** クラス選択のdisabled制御 */
  @Prop()
  private disabledClassSelect!: boolean

  /** コース選択変更時のイベント */
  @Prop()
  private changeCourseSelect!: () => Promise<void>

  /** 確認ボタン押下時のイベント */
  @Prop()
  private eventSubmit!: () => void

  /** ニックネーム */
  public nickname: string = ''

  /** ログインID */
  public loginId: string = ''

  /** 生徒識別子 */
  public identifyTag: string = ''

  /** パスワード */
  public password: string = ''

  /** 確認パスワード */
  public confirmPassword: string = ''

  /**
   * 送信ボタンのdisabled制御
   *
   * @returns 未入力や未選択があった場合はtrue
   */
  private get submitDisabled(): boolean {
    // ニックネーム、ログインID、パスワード、確認用パスワードのいずれかが未入力の場合true
    // passwordに関してはユーザから空白文字が判別できない為、通常の存在チェックのみ行う
    if (StringUtils.isBlank(this.nickname) || !this.loginId || !this.password || !this.confirmPassword) {
      return true
    }

    // 学年、教室、コース、クラスのいずれかが未選択の場合はtrue
    if (
      this.gradeSelect.selectedValue() === this.defaultGradeCode ||
      this.branchSelect.selectedValue() === this.defaultBranchCode ||
      this.courseSelect.selectedValue() === this.defaultCourseCode ||
      this.classSelect.selectedValue() === this.defaultClassCode
    ) {
      return true
    }

    return false
  }

  /**
   * モーダルを開く
   */
  public show(): void {
    this.nickname = ''
    this.loginId = ''
    this.identifyTag = ''
    this.password = ''
    this.confirmPassword = ''
    this.modalWindow.show()
  }

  /**
   * モーダルを閉じる
   */
  public hide(): void {
    this.modalWindow.hide()
  }
}
